import React, { useState, useEffect } from "react";
import "./../../../assets/css/purchase/form.css";

// Components
import Breadcrumbs from "../../components/Breadcrumbs";
import Sidebar from "../../components/Sidebar";
import ReportsTable from "../../components/Content/ReportsTable";

// Utils
import { formatStringDateToDate } from "../../../utils/DateUtils";
import { getAlert, getDataWithJoin } from "../../../utils/SamuiUtils";
import Navbar from "../../components/Modal/Navbar";

const OverdueLoanCrateReport = () => {
  // ตัวแปรเก็บชื่อหน้าจอ
  const [name, setName] = useState(null);

  // ข้อมูลที่แสดงรายงาน
  const [filteredData, setFilteredData] = useState([]);

  // สำหรับ Table รายงาน
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(16);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    // เริ่มต้นหน้าจอ (เปิดครั้งแรก)
    setName("5. รายงานลูกค้ายืมลัง แล้วไม่สั่งเกินสัปดาห์");
    setFilteredData([]);
  };

  const handleSearch = async () => {
    try {
      setFilteredData([]);

      let query = "";

      // SELECT
      //     WH.WHDoc_Cust_Code AS WHDoc_Cust_Code,
      //     WH.T_WH_NAME_CHECKDOCTYPE AS T_WH_NAME_CHECKDOCTYPE,
      //     WH.WHDoc_Date AS WHDoc_Date,
      //     WD.Item_Qty AS Item_Qty,
      //     WD.WHDoc_No AS WHDoc_No,
      //     MAX(SO.Doc_Date) AS LastSaleDate
      // FROM API_1001_WHDOC_H WH
      // LEFT JOIN API_1002_WHDOC_D WD ON (WD.WHDoc_Id = WH.WHDoc_Id AND WD.Comp_Id = 2)
      // LEFT JOIN API_0701_SO_H SO ON (WH.WHDoc_Cust_Id = SO.AR_ID AND SO.Comp_Id = 2)
      // WHERE WH.Comp_Id = 2 AND WH.WHDoc_Type = 5 -- ใบยืมลัง
      // GROUP BY
      //     WH.WHDoc_Cust_Code,
      //     WH.T_WH_NAME_CHECKDOCTYPE,
      //     WH.WHDoc_Date,
      //     WD.Item_Qty,
      //     WD.WHDoc_No
      // HAVING
      //     MAX(SO.Doc_Date) < DATEADD(DAY, -7, GETDATE()) -- ใบขายล่าสุดเกิน 7 วันจากปัจจุบัน
      //     --OR MAX(SO.Doc_Date) IS NULL -- ลูกค้าที่ไม่มีใบขาย
      // ORDER BY WH.WHDoc_Date DESC;

      query += `
                WHERE WH.Comp_Id = ${window.localStorage.getItem("company")} 
                AND WH.WHDoc_Type = 5 -- ใบยืมลัง
                GROUP BY 
                    WH.WHDoc_Cust_Code,
                    WH.T_WH_NAME_CHECKDOCTYPE,
                    WH.WHDoc_Date,
                    WD.Item_Qty,
                    WD.WHDoc_No
                HAVING 
                    MAX(SO.Doc_Date) < DATEADD(DAY, -7, GETDATE()) -- ใบขายล่าสุดเกิน 7 วันจากปัจจุบัน
                    --OR MAX(SO.Doc_Date) IS NULL -- ลูกค้าที่ไม่มีใบขาย
                ORDER BY WH.WHDoc_Date DESC
            `;

      const response = await getDataWithJoin(
        `
                 WH.WHDoc_Cust_Code AS WHDoc_Cust_Code,
                 WH.T_WH_NAME_CHECKDOCTYPE AS T_WH_NAME_CHECKDOCTYPE,
                 WH.WHDoc_Date AS WHDoc_Date,
                 WD.Item_Qty AS Item_Qty,
                 WD.WHDoc_No AS WHDoc_No
                --MAX(SO.Doc_Date) AS LastSaleDate
                `,
        `API_1001_WHDOC_H WH`,
        `
                LEFT JOIN API_1002_WHDOC_D WD ON (WD.WHDoc_Id = WH.WHDoc_Id AND WD.Comp_Id = ${window.localStorage.getItem(
                  "company"
                )})
                LEFT JOIN API_0701_SO_H SO ON (WH.WHDoc_Cust_Id = SO.AR_ID AND SO.Comp_Id = ${window.localStorage.getItem(
                  "company"
                )})
                `,
        query.trim()
      );

      if (response && response.length > 0) {
        setFilteredData(response);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.message || error.message);
    }
  };

  return (
    <>
      <Navbar />
      <div className="main-panel">
        <div className="container">
          <div className="page-inner">
            <div className="page-header d-flex justify-content-between align-items-center">
              <Breadcrumbs
                page={name}
                items={[
                  { name: "รายงาน", url: "/reports" },
                  { name: name, url: "/overdue-loan-crate-report" },
                ]}
              />
            </div>
            <div className="row">
              {/* Criteria */}
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <h4>เงื่อนไขการค้นหา</h4>
                  </div>
                  <div className="card-body">
                    <form className="row g-3">
                      <div className="col-md-12 d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-lg shadow text-white"
                          style={{
                            width: "10%",
                            marginRight: "20px",
                            backgroundColor: "#EF6C00",
                            fontSize: "16px",
                          }}
                          onClick={() => handleSearch()}
                        >
                          <i className="fas fa-search" /> ค้นหา
                        </button>
                        <button
                          type="button"
                          className="btn btn-lg shadow text-white"
                          style={{
                            width: "10%",
                            backgroundColor: "#EF6C00",
                            fontSize: "16px",
                          }}
                          onClick={() => initialize()}
                        >
                          <i className="fas fa-undo" /> เริ่มใหม่
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              {/* ReportsTable */}
              <ReportsTable
                currentItems={currentItems}
                currentPage={currentPage}
                handlePageChange={(pageNumber) => setCurrentPage(pageNumber)}
                dataMasterList={filteredData}
                itemsPerPage={itemsPerPage}
                fieldMappings={{
                  arCode: "T_WH_Code",
                  arName: "T_WH_NAME_CHECKDOCTYPE",
                  lastDate: "Last_Date",
                  amount: "Amount",
                  ibNo: "Ib_No",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OverdueLoanCrateReport;
